<template>
  <div class="field">
    <label
      :for="`${filter.id}-filter`"
      v-text="`Select ${filter.attributes.title}`"
    />
    <Multiselect
      :id="`${filter.id}-filter`"
      v-model="selectedOptions"
      label="label"
      multiple
      searchable
      track-by="value"
      :loading="optionsLoading"
      :options="options"
      :options-limit="options.length"
      :placeholder="`Select ${filter.attributes.title}`"
      :clear-on-select="false"
      :close-on-select="false"
      @search-change="handleSearchChange"
    />
  </div>
</template>

<script type="text/babel">
import { get, debounce } from 'lodash'
import Multiselect from 'vue-multiselect'
import FilterDescriptions from 'Membership/Resources/assets/js/mixins/filter-descriptions'

export default {
  name: 'SelectFilter',
  components: {
    Multiselect: Multiselect,
  },
  mixins: [FilterDescriptions],
  props: {
    filter: {
      type: Object,
      required: true,
    },
    schema: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedOptions: [],
      builtSchema: {
        values: [],
      },
      apiOptions: [],
      optionsLoading: false,
    }
  },
  computed: {
    schemaRequired() {
      return this.filter.attributes.schema_required
    },
    options() {
      if (this.optionType === 'api') {
        return this.apiOptions
      } else {
        const options = this.schema.options

        return Array.isArray(options)
          ? options
          : Object.keys(options).map(key => ({
            label: options[key],
            value: key,
          }))
      }
    },
    optionType() {
      return this.schema.option_type
    },
  },
  watch: {
    selectedOptions() {
      this.builtSchema.values = this.selectedOptions.map(element => element.value)

      this.$emit('schemaAdjusted', {
        schema: this.builtSchema,
        description: this.buildSelectFilterDescription(this.filter, this.selectedOptions),
      })
    },
  },
  mounted() {
    if (this.optionType === 'api') {
      this.fetchApiOptions('')
    }
  },
  methods: {
    fetchApiOptions: debounce(function (search) {
      this.optionsLoading = true

      let uri = `${this.schema.options.uri}?`

      if (this.schema.options.query_params.hasOwnProperty('search')) {
        uri = `${uri}${this.schema.options.query_params.search}=${search}&`
      }

      if (this.schema.options.query_params.hasOwnProperty('count')) {
        uri = `${uri}${this.schema.options.query_params.count}=100`
      }

      this.$api.active().get(uri).then((response) => {
        this.apiOptions = response.data.data.map(option => ({
          label: get(option, this.schema.options.map.label),
          value: get(option, this.schema.options.map.value),
        }))

        this.optionsLoading = false
      })
    }, 500),
    handleSearchChange(search){
      this.fetchApiOptions(search)
    },
  },
}
</script>
